import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'

export default function Layout() {
    return (
        <div className="flex h-screen w-screen bg-neutral-100 overflow-hidden">
            <Sidebar />

            {/* Main Content */}
            <div className="flex flex-col flex-1">
                {/* Sticky Header */}
                <div className="sticky top-0 z-50 shadow-sm bg-white">
                    <Header />
                </div>

                {/* Scrollable Main Content */}
                <main className="flex-1 overflow-y-auto p-6">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}
